export const fileField = `
targetPath,
path{
  default,
  sd,
  mq,
  hq,
  maxresde,
}`;
